import cx from 'clsx';
import * as React from 'react';

import * as styles from './RosreestrItemValue.css';
import { IRosreestrItemValue } from '../../../types/rosreestr';
import { RosreestrItemTooltip } from '../RosreestrItemTooltip';

interface IRosreestrItemValueProps {
  items: IRosreestrItemValue[];
  alignRight?: boolean;
}

export function RosreestrItemValue({ items, alignRight }: IRosreestrItemValueProps) {
  return (
    <>
      {items.map(prop => (
        <div className={cx(styles['container'], alignRight && styles['align-right'])} key={prop.value}>
          <div className={styles['text']}>{prop.value}</div>
          {prop.hoverText && (
            <RosreestrItemTooltip
              description={prop.hoverText.description}
              title={prop.hoverText.title}
              informerLevel={prop.informerLevel}
            />
          )}
        </div>
      ))}
    </>
  );
}
